import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { SetupRecoveryService, UnfinishedSetup } from '@/services/agent/recovery';

const QUERY_KEY = ["unfinished-setups"];

export const useUnfinishedSetups = () => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => SetupRecoveryService.getUnfinishedSetups(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const markAsAbandonedMutation = useMutation({
    mutationFn: (conversationId: string) => SetupRecoveryService.markSetupAsAbandoned(conversationId),
    onSuccess: (_, conversationId) => {
      // Optimistically update the cache
      queryClient.setQueryData<UnfinishedSetup[]>(QUERY_KEY, (old) => old?.filter((setup) => setup.elevenlabs_id !== conversationId) ?? []);
    },
  });

  const refetch = () => query.refetch();

  return {
    unfinishedSetups: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    markAsAbandoned: markAsAbandonedMutation.mutateAsync,
    isMarkingAbandoned: markAsAbandonedMutation.isPending,
    refetch,
  };
};
